var render = function render(){var _vm=this,_c=_vm._self._c;return _c('contents-table',_vm._g({attrs:{"contents":_vm.objectives,"readonly":_vm.readonly,"modalMessage":_vm.modalMessage}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }